import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { LanguageProvider } from "./context/LanguageContext";
import { captureFirstTouch } from "./services/FirstTouchService";
import { captureEmailTouch } from "./services/EmailTouchService";

// Before routing: redirects (e.g. /register -> /get-started) drop the query
// string and the original landing path.
captureFirstTouch();
// Marketing email links carry ?es=<sendId>; posted once signed in (UserContext).
captureEmailTouch();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>,
);
